<div class="download-popup">
    <div class="download-header">
        <h3>Download</h3>
        <div class="close-button" (click)="onCancel()"></div>
    </div>

    <div class="downloads-container">
        <div class="download-item">
            <h6 class="download-id">{{download.fileName}}</h6>
            <mat-progress-bar [mode]="download.progress ?'determinate' : 'indeterminate'"
                [value]="download.progress"></mat-progress-bar>
            <h6 class="download-progress">{{download.progress}}{{download.progress ? '%': ''}} {{download.status}}</h6>
        </div>
    </div>

    <div class="cancel-button">
        <button class="create-action" (click)="onCancel()">
            <span>Cancel</span>
        </button>
    </div>

</div>